import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';

import { routes } from './app.routes';
import { loadingInterceptor } from './services/interceptors/loading.interceptor';
import { authInterceptor } from './services/interceptors/auth.interceptor';
import { errorInterceptor } from './services/interceptors/error.interceptor';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },

    // ZONEFUL — modo suportado pela receita oficial do DSGov para Angular 21.
    // O stack (jQuery, Bootstrap-JS, ngx-bootstrap, ngx-datatable) pressupoe
    // change detection via zone.js. NAO usar provideZonelessChangeDetection
    // aqui — foi o que causava o NG0908. Componentes novos (ex.: novo Simples
    // Nacional) podem ser escritos em estilo signals e rodam normalmente sob zone.
    // IMPORTANTE: o zone.js precisa estar instalado (npm i zone.js) e listado
    // nos polyfills do angular.json (build e test) — so este provider nao basta.
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Animacoes: forma UNICA (o original tinha 3 duplicatas — provideAnimations()
    // e importProvidersFrom(BrowserAnimationsModule) — removidas). Necessaria para
    // modais/tooltips do ngx-bootstrap e componentes DSGov funcionarem com animacao.
    provideAnimationsAsync(),

    provideMonacoEditor({
      baseUrl: 'assets/monaco-editor',
      defaultOptions: { scrollBeyondLastLine: false },
    }),

    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),

    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor, errorInterceptor])),

    // REMOVIDO do original: importProvidersFrom([BrowserModule, BrowserAnimationsModule]).
    // BrowserModule e provido automaticamente por bootstrapApplication em apps
    // standalone; BrowserAnimationsModule era a 3a via duplicada de animacao.
  ],
};